import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import type { PitchCategory } from "@/types/camping";

/** Lädt die Platzkategorien des Mandanten. */
export function usePitchCategories(active = true) {
  const [categories, setCategories] = useState<PitchCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(() => {
    setLoading(true);
    api
      .get<PitchCategory[]>("/api/v1/pitch-categories")
      .then((list) => {
        setCategories(list);
        setError(null);
      })
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!active) return;
    reload();
  }, [active, reload]);

  return { categories, loading, error, reload };
}
